import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from "@angular/material/dialog";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-event-reg-confirm",
  standalone: true,
  imports: [CommonModule, MatDialogModule],
  templateUrl: "./event-reg-confirm.component.html",
  styleUrls: ["./event-reg-confirm.component.scss"],
})
export class EventRegConfirmComponent {
  constructor(public dialogRef: MatDialogRef<EventRegConfirmComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {}

  onClose(): void {
    this.dialogRef.close(false);
  }

  onSubmit(): void {
    this.dialogRef.close(true);
  }
}
